import { appRoutes, isInTwoFactorAuthenticationLoginFlow } from '#services';
export const inviteRoutePredicate = ({ currentUser, location, }) => {
    if (!currentUser && location?.state?.shouldGoToRegister) {
        return {
            isSuccess: false,
            navigateTo: appRoutes.register(),
        };
    }
    if (isInTwoFactorAuthenticationLoginFlow(currentUser) ||
        (!currentUser && location?.state?.shouldGoToLogin)) {
        return {
            isSuccess: false,
            navigateTo: appRoutes.login(),
        };
    }
    if (!currentUser) {
        return { isSuccess: true };
    }
    if (Boolean(currentUser) && !currentUser.emailVerified) {
        return { isSuccess: false, navigateTo: appRoutes.verifyEmail() };
    }
    if (Boolean(currentUser) &&
        !currentUser.pendingInvitation &&
        !location?.state?.pendingInvite) {
        return {
            isSuccess: false,
            navigateTo: '/workspaces',
        };
    }
    if (Boolean(currentUser) && currentUser.pendingInvitation) {
        // If there is user pending invite we should delete the one from the location
        return {
            isSuccess: true,
            locationState: {
                pendingInvite: undefined,
            },
        };
    }
    return {
        isSuccess: true,
    };
};
